/** Decide ownership at the physical press, before Winit queues its event. Checking
 * the cursor next render can drop a valid click after it has moved onto the HUD,
 * or accidentally admit a countdown press after combat has just started.
 */
export function guardCanvasMouse(canvas: HTMLCanvasElement, enabled: () => boolean): () => void {
  const guard = (event: MouseEvent) => {
    if (event.type === "pointermove") {
      const button = [1, 4, 2, 8, 16][event.button] ?? 0;
      // Winit reports chorded presses/releases as pointermove. Ordinary motion
      // and ALL releases must still reach it, including outside the canvas.
      if ((event.buttons & button) === 0) return;
    }
    if (enabled() && event.target === canvas &&
        canvas.ownerDocument.elementFromPoint(event.clientX, event.clientY) === canvas) return;
    event.stopImmediatePropagation();
  };
  // Winit receives pointerdown for the first button and pointermove for chords.
  canvas.addEventListener("pointerdown", guard, true);
  canvas.addEventListener("pointermove", guard, true);
  canvas.addEventListener("mousedown", guard, true);
  return () => {
    canvas.removeEventListener("pointerdown", guard, true);
    canvas.removeEventListener("pointermove", guard, true);
    canvas.removeEventListener("mousedown", guard, true);
  };
}
